var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
// eslint-disable-next-line import/prefer-default-export
export var SyfLoaderWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin: 50px 0 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin: 50px 0 0;\n"])));
var templateObject_1;
